import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function LeadershipSection() {
  return <Section background="ivory" className="bg-purple-100" data-id="element-234" data-mp="318h7a5kkqo3e">
      <div className="max-w-5xl mx-auto" data-id="element-235" data-mp="3f0f7ts07zbny">
        <FadeIn data-id="element-236" data-mp="3f05h227cp0h7">
          <div className="text-sm uppercase tracking-widest text-charcoal/50 font-semibold mb-12 text-center" data-id="element-237" data-mp="3ezvt0k5v93e5">
            Leadership
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-238" data-mp="2nais4xyfinmu">
          <div className="md:col-span-5 flex justify-center md:justify-end" data-id="element-239" data-mp="2iaxx2ymdqzfe">
            <FadeIn delay={200} data-id="element-240" data-mp="2wa5wnsmgg9k4">
              <div className="w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden border-4 border-white shadow-2xl relative" data-id="element-241" data-mp="2wb8l7twb1zwv">
                <img src="https://cdn.magicpatterns.com/uploads/ijqBq6iUCS24z2PrPbzfDo/IMG_4829.jpg" alt="Mukisa Kakembo" className="w-full h-full object-cover object-[center_28%] hover:scale-105 transition-all duration-700" data-id="element-242" data-mp="2r9rl40lnahhc" />
              </div>
            </FadeIn>
          </div>

          <div className="md:col-span-7 text-center md:text-left" data-id="element-243" data-mp="2lx86o2n7gpqj">
            <FadeIn delay={400} data-id="element-244" data-mp="2lzm42i5cye19">
              <h3 className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-245" data-mp="2qwkuoqptc2up">
                Mukisa Kakembo
              </h3>
              <div className="text-purple-700 font-medium tracking-wide mb-6 uppercase text-sm" data-id="element-246" data-mp="2vvfbjn47zhc6">
                Founder & CEO
              </div>
              <p className="text-lg text-charcoal/70 leading-relaxed max-w-lg mx-auto md:mx-0" data-id="element-247" data-mp="2370ay5lu51kd">
                Mukisa Kakembo leads Fem Entity with a vision to redefine how
                women experience wellness globally — merging ethical frameworks,
                technology, and community to build a new category of care.
              </p>
            </FadeIn>
          </div>
        </div>

        <div className="mt-20 md:mt-24 pt-16 border-t border-charcoal/10 grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-248" data-mp="1kgs8lppymf58">
          <div className="md:col-span-5 flex justify-center md:justify-start md:order-2" data-id="element-249" data-mp="1cfb08qedirt3">
            <FadeIn delay={200} data-id="element-250" data-mp="18faj2xzw42ic">
              <div className="w-52 h-52 md:w-64 md:h-64 rounded-full overflow-hidden border-4 border-white shadow-xl relative" data-id="element-251" data-mp="18dzdqtqsqmp4">
                <img src="https://cdn.magicpatterns.com/uploads/nCkCLTRQjnaYLpN5habq5z/Heather.png" alt="Heather Fedorchuk" className="w-full h-full object-cover hover:scale-105 transition-all duration-700" data-id="element-252" data-mp="1m7qdxbin0u86" />
              </div>
            </FadeIn>
          </div>

          <div className="md:col-span-7 text-center md:text-right md:order-1" data-id="element-253" data-mp="13fo6mqrvyqal">
            <FadeIn delay={400} data-id="element-254" data-mp="ygl0f3066e11">
              <h3 className="text-2xl md:text-3xl font-serif text-charcoal mb-2" data-id="element-255" data-mp="yf9uawj94u6r">
                Heather Fedorchuk
              </h3>
              <div className="text-purple-700 font-medium tracking-wide mb-6 uppercase text-sm" data-id="element-256" data-mp="2ewnxdhyl4x2i">
                UX/UI Designer
              </div>
              <p className="text-lg text-charcoal/70 leading-relaxed max-w-lg mx-auto md:ml-auto md:mr-0" data-id="element-257" data-mp="3rstt215u2gpj">
                Heather Fedorchuk brings a people-first, human-centric
                perspective to Fem Entity, rooted in clarity, empathy, and
                thoughtful design. She uses that perspective to create
                experiences that feel intuitive, useful, and grounded in real
                life.
              </p>
            </FadeIn>
          </div>
        </div>

        <div className="mt-20 md:mt-24 pt-16 border-t border-charcoal/10 grid grid-cols-1 md:grid-cols-12 gap-12 items-center" data-id="element-258" data-mp="jdt9jvknsgdf">
          <div className="md:col-span-5 flex justify-center md:justify-end" data-id="element-259" data-mp="5l3pvxslrnjh">
            <FadeIn delay={200} data-id="element-260" data-mp="ak6jmm34u7c5">
              <div className="w-52 h-52 md:w-64 md:h-64 rounded-full overflow-hidden border-4 border-white shadow-xl relative" data-id="element-261" data-mp="ajev1v7yd9vd">
                <img src="https://cdn.magicpatterns.com/uploads/7X76Ah3K57xXF6rkKSuh6o/Image_from_iOS.jpg" alt="Arpan Thind" className="w-full h-full object-cover object-[51%_36%] scale-[2.3] origin-[51%_36%]" data-id="element-262" data-mp="y8ptv75qsu6v" />
              </div>
            </FadeIn>
          </div>

          <div className="md:col-span-7 text-center md:text-left" data-id="element-263" data-mp="31jdz18y191si">
            <FadeIn delay={400} data-id="element-264" data-mp="2wl2osx3tsp9r">
              <h3 className="text-2xl md:text-3xl font-serif text-charcoal mb-2" data-id="element-265" data-mp="2wm4b5xqaky6s">
                Arpan Thind
              </h3>
              <div className="text-purple-700 font-medium tracking-wide mb-6 uppercase text-sm" data-id="element-266" data-mp="3tak1hw187bky">
                Marketing Manager
              </div>
              <p className="text-lg text-charcoal/70 leading-relaxed max-w-lg mx-auto md:mx-0" data-id="element-267" data-mp="3kii303apw5db">
                Arpan Thind leads Fem Entity’s social media marketing with a
                focus on building brand awareness, growing an engaged
                community, and connecting women with the resources they need.
                Through creative storytelling, strategic campaigns, and
                meaningful outreach, she works to expand Fem Entity’s reach and
                make women’s health a bigger part of everyday conversations.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </Section>;
}